const SuperEnalotto = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={66} height={72} fill="none">
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <circle cx={33} cy={39.5} r={32} fill="#DEEA96" />
        <mask
          id="c"
          width={64}
          height={65}
          x={1}
          y={7}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "alpha",
          }}
        >
          <circle cx={33} cy={39.5} r={32} fill="#ADDFE8" />
        </mask>
      </g>
      <path
        fill="#014E5C"
        d="M59.606 48.692 18.74 56.097l-1.932-10.66 19.145-10.81 21.72 3.404 1.932 10.66Z"
      />
      <path
        fill="#014E5C"
        d="m39.173 52.394-20.432 3.703-1.932-10.66 19.145-10.81 3.22 17.767Z"
      />
      <path
        fill="#BED62F"
        d="m21.317 70.311 21.72 3.404-4.507-24.874-21.72-3.404 4.507 24.874Z"
      />
      <path
        fill="#F2F7D5"
        d="M62.182 62.907 43.037 73.716 38.53 48.842l19.145-10.81 4.507 24.875Z"
      />
      <path
        fill="#BED62F"
        d="M64.454 45.062 45.47 56.76l-6.94-7.918 19.145-10.81 6.779 7.03Z"
      />
      <path
        fill="#9EB02E"
        d="m12.928 54.398 21.881 4.293 3.72-9.85-21.72-3.404-3.88 8.961Z"
      />
    </g>
    <path
      fill="url(#d)"
      d="m4.074 38.358 3.27.13 1.854-2.54 1.01 3.06 3.135 1.03-2.647 1.759.084 3.177-2.646-1.972-3.084.933 1.012-2.978-1.988-2.6Z"
    />
    <path
      fill="url(#e)"
      d="m47.701 28.796 1.733-2.815-1.336-3.023 3.212.778 2.463-2.205.252 3.296 2.858 1.66-3.056 1.26-.696 3.23-2.142-2.518-3.288.337Z"
    />
    <g clipPath="url(#f)">
      <path
        fill="url(#g)"
        d="M37.2 13.015 27.105 6.222c-.825-.553-1.993-.215-2.407.706l-.885 1.95c-.19.415-1.085 2.514-2.67 3.409-1.587.895-3.857.587-4.315.539l-2.144-.239c-1.01-.114-1.903.71-1.843 1.695l.738 12.08 23.616-13.346h.005Z"
      />
      <path
        fill="url(#h)"
        d="M37.2 13.015 27.105 6.222c-.825-.553-1.993-.215-2.407.706l-.885 1.95c-.19.415-1.085 2.514-2.67 3.409-1.587.895-3.857.587-4.315.539l-2.144-.239c-1.01-.114-1.903.71-1.843 1.695l.738 12.08 23.616-13.346h.005Z"
      />
      <path
        fill="url(#i)"
        d="M38.983 13.618 35.021 2.309c-.482-1.382-2.428-1.532-3.232-.255l-3.016 4.798c-1.532 2.436-4.696 3.377-7.256 2.156l-1.602-.766c-.708-.336-1.567.149-1.637.925l-.156 1.76c-.247 2.807-2.681 5.026-5.574 5.088l-5.697.13c-1.519.032-2.382 1.769-1.433 2.886l7.778 9.151L38.982 13.62l.001-.002Z"
      />
      <path
        fill="#014E5C"
        d="M22.7 11.68c-1.175-.334-2.444.33-2.833 1.486a2.085 2.085 0 0 0 1.425 2.696c1.178.334 2.444-.33 2.834-1.485a2.085 2.085 0 0 0-1.426-2.696Z"
      />
      <path
        fill="#008057"
        d="M13.344 19.84a1.654 1.654 0 0 0-2.002 1.05 1.475 1.475 0 0 0 1.007 1.907 1.654 1.654 0 0 0 2.003-1.05 1.475 1.475 0 0 0-1.008-1.907ZM33.705 8.339a1.654 1.654 0 0 0-2.004 1.048 1.475 1.475 0 0 0 1.008 1.907 1.654 1.654 0 0 0 2.003-1.05 1.475 1.475 0 0 0-1.008-1.907l.001.002Z"
      />
      <path
        fill="url(#j)"
        d="M25.677 15.546c-1.705-.334-3.445.649-4.023 2.273a3.517 3.517 0 0 1-1.3 1.693c-5.28 3.65-8.43 7.559-7.336 9.469l2.77 4.83L42.527 18.71l-2.772-4.83c-1.094-1.907-6.09-1.213-11.949 1.425-.67.301-1.42.388-2.13.248l.004-.002-.002-.004Z"
      />
      <path
        fill="url(#k)"
        d="M25.677 15.546c-1.705-.334-3.445.649-4.023 2.273a3.517 3.517 0 0 1-1.3 1.693c-5.28 3.65-8.43 7.559-7.336 9.469l2.77 4.83L42.527 18.71l-2.772-4.83c-1.094-1.907-6.09-1.213-11.949 1.425-.67.301-1.42.388-2.13.248l.004-.002-.002-.004Z"
      />
      <path
        fill="#FFF3BB"
        d="M26.756 22.073c-7.384 4.17-12.295 9.427-10.967 11.74 1.327 2.314 8.388.808 15.773-3.363 7.384-4.17 12.295-9.427 10.966-11.74-1.326-2.314-8.388-.807-15.772 3.363Z"
      />
      <path
        fill="#FB0"
        d="M27.948 24.145c-5.625 3.177-9.56 6.838-8.79 8.18.767 1.34 5.95-.15 11.574-3.325 5.624-3.176 9.56-6.837 8.791-8.177-.768-1.34-5.951.149-11.574 3.324l-.001-.002Z"
      />
    </g>
    <defs>
      <linearGradient
        id="d"
        x1={4.074}
        x2={12.061}
        y1={38.358}
        y2={42.505}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAF1F" />
        <stop offset={1} stopColor="#FF900E" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={47.701}
        x2={55.328}
        y1={28.796}
        y2={24.009}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAF1F" />
        <stop offset={1} stopColor="#FF900E" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={12.821}
        x2={26.366}
        y1={16.724}
        y2={16.119}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF0AE" />
        <stop offset={1} stopColor="#FBC56D" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={19.65}
        x2={25.435}
        y1={9.364}
        y2={19.772}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAF1F" />
        <stop offset={1} stopColor="#FF900E" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={18.883}
        x2={25.995}
        y1={8.273}
        y2={21.068}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB0" />
        <stop offset={1} stopColor="#FFD80E" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={20.09}
        x2={30.937}
        y1={24.628}
        y2={18.404}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEF0AE" />
        <stop offset={1} stopColor="#FBC56D" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={23.35}
        x2={29.176}
        y1={15.889}
        y2={26.37}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB0" />
        <stop offset={1} stopColor="#FFD80E" />
      </linearGradient>
      <clipPath id="a">
        <rect width={66} height={65} y={6.5} fill="#fff" rx={32.5} />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M0 6.5h66v65H0z" />
      </clipPath>
      <clipPath id="f">
        <path fill="#fff" d="M4 16.547 33.768 0l12.41 22.325L16.41 38.872z" />
      </clipPath>
    </defs>
  </svg>
)
export { SuperEnalotto }
